import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import { useAuthContext } from '@isyc-react/auth/modules/context';
import { Spinner } from '@isyc-react/design/bootstrap';
import { useDossierAddParticipantFromTemplateMutationPromise } from '@isyc-react/oc-api';
import { useCreateDossierFromTemplateMutationPromise } from '@isyc-react/oc-api/queries/dossier/dossier-create-from-template';
import { nsnewo } from "../../../i18n/namespaces";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const CreateStudentDossierFromTemplateContainer = props => {
  const {
    templateCode,
    participantTemplateCode,
    createDossierInput,
    onError,
    Renderer = DefaultCreateStudentDossierFromTemplateRenderer,
    onSuccess
  } = props;
  const {
    user
  } = useAuthContext();
  const [isLoading, setIsLoading] = React.useState(false);
  const createDossierFromTemplate = useCreateDossierFromTemplateMutationPromise();
  const addDossierParticipantFromTemplate = useDossierAddParticipantFromTemplateMutationPromise();
  const onClick = () => {
    setIsLoading(true);
    createDossierFromTemplate({
      templateCode: templateCode,
      dossier: createDossierInput
    }).then(r => {
      if (r.data) {
        const dossier = r.data.dossier_createFromTemplate;
        addDossierParticipantFromTemplate({
          dossierId: dossier.id,
          personId: user.person.id,
          templateCode: participantTemplateCode
        }).then(r => {
          onSuccess && onSuccess();
        }).catch(() => {
          onError && onError();
        }).finally(() => {
          setIsLoading(false);
        });
      }
    }).catch(r => {
      setIsLoading(false);
      onError && onError();
    });
  };
  return /*#__PURE__*/React.createElement(Renderer, {
    onClick: onClick,
    isLoading: isLoading
  });
};
const DefaultCreateStudentDossierFromTemplateRenderer = props => {
  const {
    isLoading,
    onClick
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-auto p-0 pt-3 pt-md-0"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-pill btn-outline-primary border-2",
    disabled: isLoading,
    onClick: onClick
  }, t('newo.dossier.createStudentDossierFromTemplate.create'), isLoading && /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    variant: "primary",
    size: "sm",
    className: "ms-2"
  })));
};